"use client";
import {
  useSelectStore
} from "../__chunks/O6TOSNLE.js";
import {
  SelectContextProvider
} from "../__chunks/DG5U6ZEL.js";
import "../__chunks/O2PQ2652.js";
import "../__chunks/4CMBR7SL.js";
import "../__chunks/BM6PGYQY.js";
import "../__chunks/WYCIER3C.js";
import "../__chunks/C3IKGW5T.js";
import "../__chunks/S43UC3DV.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/YV4JVR4I.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/select/select-provider.tsx
import { jsx } from "react/jsx-runtime";
function SelectProvider(props = {}) {
  const store = useSelectStore(props);
  return /* @__PURE__ */ jsx(SelectContextProvider, { value: store, children: props.children });
}
export {
  SelectProvider
};
